import { useDispatch } from "react-redux";
import { useI18N } from "@src/language/language-context";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import { updateShowOtaInstallationInProgressModal } from "@src/reducers/your-reducer";

interface UseOtaBackupProcessInProgressProps {
  activeInstallationData?: ActiveInstallationProcessPayload | null;
}

export const useOtaBackupProcessInProgress = ({
  activeInstallationData,
}: UseOtaBackupProcessInProgressProps) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const operationId =
    activeInstallationData?.update_details?.sftp_push_operation_id || "";

  const texts = {
    baseTitle: i18n("modules.otaBackupProcessInProgress.baseTitle"),
    operationIdTemplate: i18n(
      "modules.otaBackupProcessInProgress.operationIdTemplate",
    ),
    description: i18n("modules.otaBackupProcessInProgress.description"),
    showDetailsButtonText: i18n(
      "modules.otaBackupProcessInProgress.showDetailsButtonText",
    ),
  };

  const normalizedOperationId = String(operationId).trim();
  const idLabel = normalizedOperationId
    ? texts.operationIdTemplate.replace("{operationId}", normalizedOperationId)
    : "";
  const title = `${texts.baseTitle}${idLabel}`.trim();

  const handleShowDetails = () => {
    dispatch(updateShowOtaInstallationInProgressModal(true));
  };

  return {
    title,
    texts,
    handleShowDetails,
  };
};
